import React from 'react';
import styled from 'styled-components';
import { IluckydrawItem } from '@typings/store/luckydraw.interface';
import RewardSection from '@components/dataDisplay/RewardSection';

const Wrapper = styled.div`
  margin-bottom: 32px;
`;

type Props = {
  data: IluckydrawItem;
};

function RewardItemsSec({ data }: Props) {
  return (
    <Wrapper>
      <RewardSection
        itemIds={data.itemList}
        skillIds={data.skillList}
        title="주요 보상 목록"
        titleStyle="divider"
        titleFontSize="12px"
        compact
        showEmpty={false}
      />
    </Wrapper>
  );
}

export default RewardItemsSec;
